import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import compact from 'lodash/compact';
import { bindActionCreators } from 'redux';
import Close from 'yoda-core-components/lib/assets/svg/Close.svg';
import SlidePanel from 'yoda-site-components/lib/components/SlidePanel/SlidePanel';
import Message from 'yoda-site-components/lib/components/Messages/Message/Message';
import { messageTypes } from 'yoda-site-components/lib/components/Messages/Messages.config';
import MiniPDPReducer from 'yoda-site-components/lib/reducers/MiniPDPReducer';
import LoadingAction from 'yoda-site-components/lib/actions/LoadingAction';
import {
    persistError,
    miniPDPCloseError,
    miniPDPOpenError,
} from 'yoda-site-components/lib/actions/MiniPDPAction';
import CustomErrorLogger from 'yoda-site-components/lib/helpers/CustomErrorLogger/CustomErrorLogger';
import withReducerSaga from 'yoda-site-components/lib/hoc/ReducerRegistry/withReducerSaga';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const ERROR_TYPE = 'MiniPDPTimeout';

export class MiniPDPErrorSlider extends Component {
    static propTypes = {
        message: PropTypes.string,
        onMount: PropTypes.func,
        actions: PropTypes.shape({
            removeLoader: PropTypes.func,
            persistError: PropTypes.func,
            miniPDPCloseError: PropTypes.func,
            miniPDPOpenError: PropTypes.func,
        }).isRequired,
        persistError: PropTypes.bool,
        logError: PropTypes.bool,
        miniPDP: PropTypes.oneOfType([PropTypes.object]),
    };

    static defaultProps = {
        message: 'There was an error while processing your request. Please try again.',
        onMount: null,
        persistError: false,
        logError: false,
        miniPDP: {},
    };

    componentDidMount() {
        this.props.onMount && this.props.onMount();
        this.props.actions.removeLoader();
        this.props.actions.miniPDPOpenError();

        if (this.props.logError) {
            const { pageType, pageName } = get(window.digitalData, 'page.pageInfo', {});

            const details = {
                errorType: ERROR_TYPE,
                errorDescription: get(this.props, 'error.message', ''),
                pageType: compact([pageType, pageName]).join('-') || window.location.pathname,
            };
            CustomErrorLogger.triggerCustomErrorLog(details);
        }

        if (this.props.persistError) {
            this.props.actions.persistError();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (get(nextProps, 'miniPDP.error', false) !== get(this.props, 'miniPDP.error', false)) {
            this.props.actions.removeLoader();
            return true;
        }
        return false;
    }

    closeMiniPDPError = () => {
        this.props.actions.miniPDPCloseError();
    };

    render() {
        return (
            <SlidePanel
                isOpenPanel={get(this.props.miniPDP, 'error', false)}
                onClosePanel={this.closeMiniPDPError}
                panelTitle=""
                panelTitleAlignment="right"
                panelIcon="close"
                panelIconComponent={<Close />}
            >
                <div className={dt(['p-2.5'])}>
                    <Message
                        title={this.props.message}
                        type={messageTypes.error}
                        hasClose={false}
                    />
                </div>
            </SlidePanel>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            removeLoader: LoadingAction.removeLoader,
            persistError,
            miniPDPOpenError,
            miniPDPCloseError,
        },
        dispatch
    ),
});

const mapStateToProps = (store) => ({
    miniPDP: store.miniPDP,
});

export default withReducerSaga(
    [MiniPDPReducer],
    []
)(connect(mapStateToProps, mapDispatchToProps)(MiniPDPErrorSlider));
